module.exports = __webpack_public_path__ + "static/media/V2_05.f699f4fa.png";